interface IOfferArrowProps {
  className?: string;
  fill?: string;
  direction?: 'up' | 'down' | 'left' | 'right';
}

const directionMap = {
  left: 'rotate(-90deg)',
  down: 'rotate(180deg)',
  right: 'rotate(90deg)',
  up: 'rotate(0deg)',
};

const getDirection = (direction: string) => directionMap[direction] || 'rotate(0)';

export const OfferArrow = ({ className, fill = 'black', direction = 'up' }: IOfferArrowProps) => {
  return (
    <svg
      className={className}
      width="9"
      height="10"
      viewBox="0 0 9 10"
      color={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: getDirection(direction) }}
    >
      <path d="M4.5 0.5L9 5.5L0 5.5L4.5 0.5Z" fill="currentColor" />
      <path d="M4.5 9.5L4.5 4.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};
